import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import { PolygonBlueContainer } from 'src/elements/geometry/polygon.blue.styles';
import Image from 'src/elements/image/image';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import {
  ImageWrapper,
  ImageWrapperMobile,
  WorkCultureConfetti,
  WorkCultureContainer,
  WorkCultureText
} from './workCulture.styles';

interface WorkCultureProps {
  title: string;
  substitle: string;
  image: IGatsbyImageData;
  mobileImage: IGatsbyImageData;
}

const WorkCulture = ({ title, substitle, image, mobileImage }: WorkCultureProps): JSX.Element => {
  return (
    <WorkCultureContainer>
      <WorkCultureConfetti />
      <WorkCultureText>
        <FadeInAnimationWrapper>
          <Heading
            text={title}
            size="3.5em"
            sizeLg="2.5em"
            sizeMd="1.5em"
            align="center"
          />
        </FadeInAnimationWrapper>
        <FadeInAnimationWrapper style={{ display: 'grid', justifySelf: 'center' }}>
          <Paragraph
            text={substitle}
            size="1.5em"
            sizeMd="1.2em"
            align="center"
            weight="light"
          />
        </FadeInAnimationWrapper>
      </WorkCultureText>
      <ImageWrapper>
        <Image childImageSharp={image} alt="Zoom meeting" />
      </ImageWrapper>
      <ImageWrapperMobile>
        <Image childImageSharp={mobileImage} alt="Zoom meeting" />
      </ImageWrapperMobile>
      <PolygonBlueContainer position="absolute" />
    </WorkCultureContainer>
  )
}

export default WorkCulture;
